import { render, staticRenderFns } from "./SelectStyledLight.vue?vue&type=template&id=2564cd90&scoped=true&"
import script from "./SelectStyledLight.vue?vue&type=script&lang=js&"
export * from "./SelectStyledLight.vue?vue&type=script&lang=js&"
import style0 from "./SelectStyledLight.vue?vue&type=style&index=0&id=2564cd90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2564cd90",
  null
  
)

export default component.exports